import axios from 'axios';

// Whether promo is running embedded inside the One Retail shell vs. standalone. When embedded the
// shell owns the chrome and promo hides its own. Set once by create-app.js before anything reads
// it, so a plain boolean is enough.
//
// Imported by build/vite.config.mjs for STYLE_SCOPE_CLASS, so keep this module free of Vue imports.
let embedded = false;

// CSS containment scope. The class sits on the element promo mounts into (on <body> standalone),
// and build/vite.config.mjs prefixes promo's stylesheets with it.
export const STYLE_SCOPE_CLASS = 'promo-scope';

// Promo's own origin. Embedded, the document belongs to the shell, so anything resolving URLs
// against the document rather than through axios — EventSource, window.open — must be absolute.
let apiOrigin = '';

export function setEmbedded(value) {
    embedded = Boolean(value);
}

export function isEmbedded() {
    return embedded;
}

export function setApiOrigin(origin) {
    axios.defaults.baseURL = origin || '';
    apiOrigin = origin || '';
}

export function apiUrl(path) {
    return `${apiOrigin}${path}`;
}
